import Urls, { MANGOOLS_PATHS } from './Urls';
export const CampaignTypes = {
  BLACK_FRIDAY: 'BLACK_FRIDAY'
};

// Unix seconds, midnight or 23:59:59 PST (UTC-8).
const Campaigns = [{
  type: CampaignTypes.BLACK_FRIDAY,
  startTs: 1793692800,
  // Tue 3 Nov 2026
  lastDaysStartTs: 1795852800,
  // Sat 28 Nov 2026
  endTs: 1796111999,
  // Mon 30 Nov 2026 23:59:59
  registrationCutoffTs: 1791014400,
  // Sat 3 Oct 2026
  text: 'Your secret Black Friday deal: 35% off any Mangools plan, for life. SEO tools plus AI Search Watcher PRO.',
  lastDaysText: 'Ends Monday at 23:59 PST: 35% off any plan, for life.',
  buttonText: 'Get 35% off',
  url: `${Urls.MANGOOLS_APP_URL}/${MANGOOLS_PATHS.BUNDLE_INVITE}`
}];
export default Campaigns;